import { useQuery } from "@tanstack/react-query";
import { __ } from "../../../i18n/l10n";
import useJwt from "../../utils/useJwt";
import useLocaleQueryFilter from "../../utils/useLocaleQueryFilter";
import { AddressType } from "./useAccountAddress";
import { ImageType } from "./useProducts";

export enum OrderStatuses {
  "000-READY" = "000-READY",
  "100-IN_PROGRESS" = "100-IN_PROGRESS",
  "200-PROCESSED" = "200-PROCESSED", // If all cartItems are Canceled the order is Canceled
}

export const orderStatuses: { [key in OrderStatuses]: string } = {
  [OrderStatuses["000-READY"]]: __("Order ready for delivery"),
  [OrderStatuses["100-IN_PROGRESS"]]: __("Order in process"),
  [OrderStatuses["200-PROCESSED"]]: __("Order completed"),
};

export type OrderCardType = {
  id: number;
  totalMilesAmount: number;
  createdAt: string;
  status: OrderStatuses;
  defaultProductImage?: ImageType;
  localizedProductImage?: ImageType;
  defaultVariantImage?: ImageType;
  localizedVariantImage?: ImageType;
} & AddressType;

export default function useOrders() {
  const jwt = useJwt();
  const filter = useLocaleQueryFilter({ jwt });

  return useQuery<OrderCardType[], Error>(["orders/all", filter], {
    enabled: !!jwt,
  });
}
